import { sanitizeName } from '@/shared/utils/sanitizeName';

/**
 * Workspace names follow the task-name rule: whitespace becomes `-` while
 * typing (onboarding, "+ Add New Workspace", Settings rename). `trimEnd`
 * drops the trailing dashes before the name is saved.
 */
export const sanitizeWorkspaceName = (value, opts) => sanitizeName(value, opts);
